import { fetcher } from "../../../utils/Axios";
import { useQuery } from "@tanstack/react-query";
import { GET_AVG_TURNOVER_TIME_QUERY_KEY } from "../types/CommonTypes";
import { GET_AVG_TURNOVER_TIME_RESPONSE } from "../types/ResponseTypes";

async function getAvgTurnoverTime(tenantId: string, hospitalId: string, queryString: string): Promise<GET_AVG_TURNOVER_TIME_RESPONSE> {
  const baseUrl = "analytics/average-turnover-time";
  const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;
  
  const { data } = await fetcher({
    url,
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
  return data?.otData || [];
}

export default function useGetAvgTurnoverTimeQuery(tenantId: string, hospitalId: string, queryString: string = "") {
  return useQuery({
    queryKey: [GET_AVG_TURNOVER_TIME_QUERY_KEY, queryString, hospitalId],
    queryFn: () => getAvgTurnoverTime(tenantId, hospitalId, queryString),
    refetchInterval: 60000,
  });
} 